// extracted by mini-css-extract-plugin
export default {"restart":"styles_restart__JVO2W"};